import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckOutComponent } from './components/check-out/check-out.component';
const routes: Routes = [
  {
    path: '',
    component: CheckOutComponent,
    data: { breadcrumb: [{ labelKey: 'unifiedShell.pages.checkOut' }] },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentRoutingModule { }
